module.exports = __webpack_public_path__ + "img/warn_icon.57185895.svg";